const {
    DOCUMENT_NIF,
    DOCUMENT_CC,
    DOCUMENT_PP,
    DOCUMENT_PN,
    DOCUMENT_DN,
    DOCUMENT_PA,
    DOCUMENT_DA,
    DOCUMENT_NIE,
    DOCUMENT_PASSPORT,
} = require('commons-components/src/constants/documentCodes'); //TODO: NOTE: no funciona alias commonsConstants

const COUNTRY_CODE_ES = 'es';
const COUNTRY_CODE_PT = 'pt';
const COUNTRY_CODE_NL = 'nl';
const COUNTRY_CODE_DE = 'de';
const COUNTRY_CODE_EN = 'en';

const COUNTRY_PREFIX_UA = '+380';
const COUNTRY_PREFIX_ES = '+34';
const COUNTRY_PREFIX_PT = '+351';
const COUNTRY_PREFIX_NL = '+31';
const COUNTRY_PREFIX_DE = '+49';

const COUNTRY_DOCUMENT_TYPE_DNI = DOCUMENT_NIF;
const COUNTRY_DOCUMENT_TYPE_NIE = DOCUMENT_NIE;
const COUNTRY_DOCUMENT_TYPE_PASSPORT = DOCUMENT_PASSPORT;

const COUNTRY_DOCUMENT_TYPE_DA = DOCUMENT_DA;
const COUNTRY_DOCUMENT_TYPE_PA = DOCUMENT_PA;

const COUNTRY_DOCUMENT_TYPE_CC = DOCUMENT_CC;
const COUNTRY_DOCUMENT_TYPE_PP = DOCUMENT_PP;

const COUNTRY_DOCUMENT_TYPE_DN = DOCUMENT_DN;
const COUNTRY_DOCUMENT_TYPE_PN = DOCUMENT_PN;

const COUNTRY_DOCUMENT_TYPE_DNI_LABEL = 'DNI';
const COUNTRY_DOCUMENT_TYPE_NIE_LABEL = 'NIE';

const COUNTRY_TREATMENT_DEFAULT = '';
const COUNTRY_TREATMENT_DR = 'Dr.';
const COUNTRY_TREATMENT_PROF = 'Prof.';
const COUNTRY_TREATMENT_PROFDR = 'Prof. Dr.';

const URL_PATH_ES = '/hazte-cliente';
const URL_PATH_PT = '/abrir-conta';
const URL_PATH_NL = '/klant-worden';
const URL_PATH_DE = '/kunde-werden';

const URL_STG_ES = `https://www.stg.openbank.es${URL_PATH_ES}`;
const URL_STG_PT = `https://www.stg.openbank.pt${URL_PATH_PT}`;
const URL_STG_NL = `https://www.stg.openbank.nl${URL_PATH_NL}`;
const URL_STG_DE = `https://www.stg.openbank.de${URL_PATH_DE}`;

const URL_PROD_ES = `https://www.openbank.es${URL_PATH_ES}`;
const URL_PROD_PT = `https://www.openbank.pt${URL_PATH_PT}`;
const URL_PROD_NL = `https://www.openbank.nl${URL_PATH_NL}`;
const URL_PROD_DE = `https://www.openbank.de${URL_PATH_DE}`;

const TYPE_CALL_ME_BACK_ES = 'onboarding';
const TYPE_CALL_ME_BACK_PT = 'onboardingpt';
const TYPE_CALL_ME_BACK_NL = 'onboardingnl';
const TYPE_CALL_ME_BACK_DE = 'onboardingde';

export default {
    COUNTRY_CODE_ES,
    COUNTRY_CODE_PT,
    COUNTRY_CODE_NL,
    COUNTRY_CODE_DE,
    COUNTRY_CODE_EN,
    COUNTRY_PREFIX_UA,
    COUNTRY_PREFIX_ES,
    COUNTRY_PREFIX_PT,
    COUNTRY_PREFIX_NL,
    COUNTRY_PREFIX_DE,
    COUNTRY_DOCUMENT_TYPE_DNI,
    COUNTRY_DOCUMENT_TYPE_NIE,
    COUNTRY_TREATMENT_DEFAULT,
    COUNTRY_TREATMENT_DR,
    COUNTRY_TREATMENT_PROF,
    COUNTRY_TREATMENT_PROFDR,
    COUNTRY_DOCUMENT_TYPE_DA,
    COUNTRY_DOCUMENT_TYPE_PA,
    COUNTRY_DOCUMENT_TYPE_CC,
    COUNTRY_DOCUMENT_TYPE_PP,
    COUNTRY_DOCUMENT_TYPE_DN,
    COUNTRY_DOCUMENT_TYPE_PN,
    COUNTRY_DOCUMENT_TYPE_DNI_LABEL,
    COUNTRY_DOCUMENT_TYPE_NIE_LABEL,
    COUNTRY_DOCUMENT_TYPE_PASSPORT,
    URL_STG_ES,
    URL_STG_PT,
    URL_STG_NL,
    URL_STG_DE,
    URL_PROD_ES,
    URL_PROD_PT,
    URL_PROD_NL,
    URL_PROD_DE,
    TYPE_CALL_ME_BACK_ES,
    TYPE_CALL_ME_BACK_PT,
    TYPE_CALL_ME_BACK_NL,
    TYPE_CALL_ME_BACK_DE,
    URL_PATH_ES,
    URL_PATH_PT,
    URL_PATH_NL,
    URL_PATH_DE,
};
